function pad2(n) {
  return String(n).padStart(2, "0");
}

export function fmtYMD(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function buildQuickDateRanges(today = new Date()) {
  const t = new Date(today);
  t.setHours(0, 0, 0, 0);

  // Semana actual: desde hoy - 6 días hasta hoy
  const weekStart = new Date(t);
  weekStart.setDate(t.getDate() - 6);

  // Mes actual: desde hoy hasta el primer día del mes actual
  const monthStart = new Date(t.getFullYear(), t.getMonth(), 1);

  // Mes anterior: desde último día del mes anterior hasta el primer día del mes anterior
  const lastMonthEnd = new Date(t.getFullYear(), t.getMonth(), 0);
  const lastMonthStart = new Date(t.getFullYear(), t.getMonth() - 1, 1);

  return {
    SEMANA_ACTUAL: {
      bg:"#4A3B72",
      color:"#000000",
      label: "Semana actual",
      from: fmtYMD(weekStart),
      to: fmtYMD(t),
    },
    MES_ACTUAL: {
      bg:"#7F93CE",
      color:"#FFFFFF",
      label: "Mes actual",
      from: fmtYMD(monthStart),
      to: fmtYMD(t),
    },
    MES_ANTERIOR: {
      bg:"#7F93CE",
      color:"#FFFFFF",
      label: "Mes anterior",
      from: fmtYMD(lastMonthStart),
      to: fmtYMD(lastMonthEnd),
    },
  };
}

export function calculateTotalMinutesInRange(records = []) {
  return records.reduce((total, record) => {
    return total + Math.max(0, Number(record.workedMinutes) || 0);
  }, 0);
}

export function formatHHMM(minutes) {
  const total = Math.max(0, Number(minutes) || 0);
  const hours = Math.floor(total / 60);
  const mins = total % 60;

  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
}

export function formatHoursLabel(minutes) {
  const total = Math.max(0, Number(minutes) || 0);
  const hours = Math.floor(total / 60);
  const mins = total % 60;

  return `${hours}h ${String(mins).padStart(2, "0")}m`;
}
